import moment from 'moment';
import { fetchConToken } from '../../helpers/fetch';
import { handleErrorApi } from '../../helpers/randoms';
import { types } from '../../types/types';
import { startAlerta } from '../ui/alertas';
import { finishSpinner, startSpinner } from '../ui/spinner';
import { TIPOS_ARCHIVOS_EMPADRONAMIENTO_HCE } from '../../utils/constants';
import Axios from 'axios';


export const clearReducerHce = () => {
  return { type: types.hceClearReducer };
};

export const autopercepcionClear = () => {
  return { type: types.hceAutopercepcionAfiliadoClear };
};


export const setActiveBreadcrumbHce = (activeBreadcrumb) => ({
  type: types.setActiveBreadcrumbHce,
  payload: activeBreadcrumb,
});

export const setAfiliadoEnSala = (afiEnSala) => ({
  type: types.salaEsperaAfiliadosSuccess,
  payload: afiEnSala,
});


export const setActiveStepEmpadronamiento = (activeStep) => ({
  type: types.hceEmpadronamientoSetStep,
  payload: activeStep,
});

export const setEstadoTurnosHce = (estado) => {
  return {
    type: types.reclamosUpdateEstadoTurnos,
    payload: estado,
  };
};

export const setHceSelec = (hce) => {
  return {
    type: types.SetHceSeleccionada,
    payload: hce,
  };
};

export const clearProtocolo = () => {
  return { type: types.protocoloImagenesPorIdSucces };
};
export const clearProtocolos = () => {
  return { type: types.protocoloImagenesSucces };
};
export const clearRecordatorioG = () => {
  return { type: types.recordatorioGeneralSucces };
};
export const clearRecordatorioP = () => {
  return { type: types.recordatorioPropioSucces };
};

export const setAfiliadoSeleccionadoHce = (afiliado) => {
  return {
    type: types.setDataAfiliadoHCE,
    payload: afiliado,
  };
};

export const TraerTurnosMedicos =
  (fecha, confirmado, idEfector, idCentroMedico, connectionId) => async (dispatch) => {
    let fechaModif = fecha instanceof Date ? moment(fecha).format() : '';
    try {
      const response = await fetchConToken(
        `HCE/ListadoTurnos/${fechaModif},${confirmado},${idEfector},${idCentroMedico},${connectionId}`,
      );
      const body = await response.json();
      if (response.ok) {
        dispatch({
          type: types.listaTurnosSucess,
          payload: body,
        });
      } else {
        throw body;
      }
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        'Error al cargar el listado de turnos.',
        'Ha ocurrido un error. Intente Nuevamente',
      );
    }
  };

export const FetchDataAfiliadoHCE = (idAfiliado) => async (dispatch) => {
  try {
    const response = await fetchConToken(
      `Afiliados/traerPorIdAfiliado/${idAfiliado}`,
    );
    const body = await response.json();

    if (response.ok) {
      dispatch({
        type: types.setDataAfiliadoHCE,
        payload: body,
      });
    } else {
      throw body;
    }
  } catch (error) {
    handleErrorApi(
      dispatch,
      error,
      'Error al cargar la informacion del afiliado.',
      'Ha ocurrido un error. Intente Nuevamente',
    );
  }
};

export const FetchDataAfiliadoExternoHCE = (idObraSocial, nroDocumento) => async (dispatch) => {
  try {
    const response = await fetchConToken(
      `AfiliadosExternos/buscarAfiliadoExternoEnPadron/${idObraSocial}/${nroDocumento}`,

    );
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.setDataAfiliadoHCE,
        payload: body[0],
      });
    } else {
      throw body;
    }
  } catch (error) {
    handleErrorApi(
      dispatch,
      error,
      'Error al cargar la informacion del afiliado.',
      'Ha ocurrido un error. Intente Nuevamente',
    );
  }
};

export const NuevoProblemaAfiliado = (datos) => async (dispatch) => {
  if (datos.idAfiliado === null) {
    datos.idAfiliado = 0
  }
  if (datos.idAfiliadoExterno === null) {
    datos.idAfiliadoExterno = 0
  }
  try {
    dispatch(startSpinner());

    const response = await fetchConToken(
      `HCE/IngresoProblemaPaciente`,
      datos,
      'POST',
    );
    const body = await response.json();

    if (response.ok) {
      dispatch(TraerProblemasAfiliado(datos.idAfiliado, datos.idAfiliadoExterno));
      dispatch(
        startAlerta(
          'Problema creado correctamente',
          'success',
          'Comando Exitoso',
        ),
      );
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      'Error al crear el problema.',
      'Ha ocurrido un error. Intente nuevamente',
    );
  }
};

export const CambiarEstadoDiagnostico =
  (datos, idAfiliado, idAfiliadoExterno) => async (dispatch) => {
    try {
      dispatch(startSpinner());

      const response = await fetchConToken(
        `HCE/CambiarEstadoDiagnostico`,
        datos,
        'POST',
      );
      const body = await response.json();

      if (response.ok) {
        dispatch(TraerProblemasAfiliado(idAfiliado, idAfiliadoExterno));
        dispatch(
          startAlerta(
            'Estado modificado correctamente',
            'success',
            'Comando Exitoso',
          ),
        );
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        'Error al modificar el estado.',
        'Ha ocurrido un error. Intente nuevamente',
      );
    }
  };

export const TraerProblemasAfiliado = (idAfiliado, idAfiliadoExterno) => async (dispatch) => {
  if (idAfiliado === null) {
    idAfiliado = 0
  }
  if (idAfiliadoExterno === null) {
    idAfiliadoExterno = 0
  }
  try {
    const response = await fetchConToken(
      `HCE/TraerProblemasPaciente/${idAfiliado}/${idAfiliadoExterno}`,
    );
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.problemasAfiliadoSucces,
        payload: body,
      });
    } else {
      throw body;
    }
  } catch (error) {
    handleErrorApi(
      dispatch,
      error,
      'Error al cargar problemas.',
      'Ha ocurrido un error. Intente Nuevamente',
    );
  }
};

export const TraerRecordatorioPropio =
  (idAfiliado, idAfiliadoExterno, idefectorRed, esPropio, openModal) => async (dispatch) => {
    if (idAfiliado === null) {
      idAfiliado = 0
    }
    if (idAfiliadoExterno === null) {
      idAfiliadoExterno = 0
    }
    try {
      const response = await fetchConToken(
        `HCE/Recordatorio/${idAfiliado},${idAfiliadoExterno},${idefectorRed},${esPropio}`,
      );
      const body = await response.json();
      if (response.ok) {
        dispatch({
          type: types.recordatorioPropioSucces,
          payload: body,
        });
        openModal();
      } else {
        throw body;
      }
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        'Error al cargar problemas.',
        'Ha ocurrido un error. Intente Nuevamente',
      );
    }
  };

export const updateRecordatorio = (datos) => async (dispatch) => {
  try {
    dispatch(startSpinner());

    const response = await fetchConToken(`HCE/Recordatorio`, datos, 'PUT');
    const body = await response.json();

    if (response.ok) {
      dispatch(
        startAlerta(
          'Recordatorio modificado correctamente',
          'success',
          'Comando Exitoso',
        ),
      );
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      'Error al modificar el recordatorio.',
      'Ha ocurrido un error. Intente nuevamente',
    );
  }
};

export const insertRecordatorio = (datos) => async (dispatch) => {
  try {
    dispatch(startSpinner());

    const response = await fetchConToken(`HCE/Recordatorio`, datos, 'POST');
    const body = await response.json();

    if (response.ok) {
      dispatch(
        startAlerta(
          'Recordatorio creado correctamente',
          'success',
          'Comando Exitoso',
        ),
      );
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      'Error al crear el recordatorio.',
      'Ha ocurrido un error. Intente nuevamente',
    );
  }
};

export const TraerRecordatorioGeneral =
  (idAfiliado, idAfiliadoExterno, idefectorRed, esPropio) => async (dispatch) => {
    if (idAfiliado === null) {
      idAfiliado = 0
    }
    if (idAfiliadoExterno === null) {
      idAfiliadoExterno = 0
    }
    try {
      const response = await fetchConToken(
        `HCE/Recordatorio/${idAfiliado},${idAfiliadoExterno},${idefectorRed},${esPropio}`,
      );
      const body = await response.json();
      if (response.ok) {
        dispatch({
          type: types.recordatorioGeneralSucces,
          payload: body,
        });
      } else {
        throw body;
      }
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        'Error al cargar problemas.',
        'Ha ocurrido un error. Intente Nuevamente',
      );
    }
  };

export const traerEstadosProblemas = () => async (dispatch) => {
  try {
    const response = await fetchConToken(`HCE/TraerEstadosProblemas`);
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.estadosProblemasSucces,
        payload: body,
      });
    } else {
      throw body;
    }
  } catch (error) {
    handleErrorApi(
      dispatch,
      error,
      'Error al cargar problemas.',
      'Ha ocurrido un error. Intente Nuevamente',
    );
  }
};

export const TraerEvolucionesAfiliado =
  (idProblemaPaciente) => async (dispatch) => {
    try {
      const response = await fetchConToken(
        `HCE/TraerEvolucionesPaciente/${idProblemaPaciente}`,
      );
      const body = await response.json();
      if (response.ok) {
        dispatch({
          type: types.evolucionesAfiliadoSucces,
          payload: body,
        });
      } else {
        throw body;
      }
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        'Error al cargar problemas.',
        'Ha ocurrido un error. Intente Nuevamente',
      );
    }
  };

export const TraerEvolucionesAfiliadoFecha =
  (idAfiliado, fecha) => async (dispatch) => {
    try {
      dispatch(startSpinner());
      dispatch(clearReducerHce());
      const response = await fetchConToken(
        `HCE/TraerEvolucionesPacienteFecha/${idAfiliado}?fecha=${fecha}`,
      );
      const body = await response.json();
      if (response.ok) {
        dispatch({
          type: types.evolucionesAfiliadoSucces,
          payload: body,
        });
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        'Error al cargar la Evolución.',
        'Ha ocurrido un error. Intente Nuevamente',
      );
    }
  };


export const NuevaEvolucionAfiliado = (datos) => async (dispatch) => {
  try {
    dispatch(startSpinner());
    const response = await fetchConToken(
      `HCE/IngresoEvolucionPaciente`,
      datos,
      'POST',
    );
    const body = await response.json();

    if (response.ok) {
      dispatch(TraerEvolucionesAfiliado(datos.idProblema));
      dispatch(
        startAlerta(
          'Evolucion creado correctamente',
          'success',
          'Comando Exitoso',
        ),
      );
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      'Error al crear la evolucion.',
      'Ha ocurrido un error. Intente nuevamente',
    );
  }
};

export const finalizarProblema = (datos, idAfiliado, idAfiliadoExterno) => async (dispatch) => {
  try {
    dispatch(startSpinner());
    const response = await fetchConToken(`HCE/FinalizarProblema`, datos, 'PUT');
    const body = await response.json();

    if (response.ok) {
      dispatch(TraerProblemasAfiliado(idAfiliado, idAfiliadoExterno));
      dispatch(
        startAlerta(
          'Problema finalizado correctamente',
          'success',
          'Comando Exitoso',
        ),
      );
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      'Error al finalizar el problema.',
      'Ha ocurrido un error. Intente nuevamente',
    );
  }
};

export const pasarErrorEvolucion = (datos, idProblema) => async (dispatch) => {
  try {
    dispatch(startSpinner());
    const response = await fetchConToken(
      `HCE/PasarErrorEvolucion`,
      datos,
      'PUT',
    );
    const body = await response.json();

    if (response.ok) {
      dispatch(TraerEvolucionesAfiliado(idProblema));
      dispatch(
        startAlerta(
          'Evolucion pasada a error correctamente',
          'success',
          'Comando Exitoso',
        ),
      );
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      'Error al pasar a error la evolucion.',
      'Ha ocurrido un error. Intente nuevamente',
    );
  }
};

export const pasarErrorDiagnostico =
  (datos, idAfiliado, idAfiliadoExterno) => async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response = await fetchConToken(
        `HCE/PasarErrorDiagnostico`,
        datos,
        'PUT',
      );
      const body = await response.json();
      if (response.ok) {
        dispatch(TraerProblemasAfiliado(idAfiliado, idAfiliadoExterno));
        dispatch(
          startAlerta(
            'Evolucion pasada a error correctamente',
            'success',
            'Comando Exitoso',
          ),
        );
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        'Error al pasar a error la evolucion.',
        'Ha ocurrido un error. Intente nuevamente',
      );
    }
  };

export const TraerProtocoloImagenes = (idEfector) => async (dispatch) => {
  try {
    const response = await fetchConToken(`HCE/ProtocoloImagenes/${idEfector}`);
    const body = await response.json();

    if (response.ok) {
      dispatch({
        type: types.protocoloImagenesSucces,
        payload: body,
      });
    } else {
      throw body;
    }
  } catch (error) {
    handleErrorApi(
      dispatch,
      error,
      'Error al cargar los protocolos.',
      'Ha ocurrido un error. Intente Nuevamente',
    );
  }
};

export const TraerProtocoloImagenesPorId =
  (idProtocolo) => async (dispatch) => {
    try {
      const response = await fetchConToken(
        `HCE/ProtocoloImagenesPorId/${idProtocolo}`,
      );
      const body = await response.json();

      if (response.ok) {
        dispatch({
          type: types.protocoloImagenesPorIdSucces,
          payload: body[0],
        });
      } else {
        throw body;
      }
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        'Error al cargar el protocolo.',
        'Ha ocurrido un error. Intente Nuevamente',
      );
    }
  };

export const TraerInformesPaciente = (idAfiliado, idAfiliadoExterno) => async (dispatch) => {
  idAfiliado = idAfiliado === null ? 0 : idAfiliado;
  idAfiliadoExterno = idAfiliadoExterno === null ? 0 : idAfiliadoExterno;
  try {
    const response = await fetchConToken(
      `HCE/TraerInformesPaciente/${idAfiliado}/${idAfiliadoExterno}`,
    );

    const body = await response.json();

    if (response.ok) {
      dispatch({
        type: types.informesAfiliadoSucces,
        payload: body,
      });
    } else {
      throw body;
    }
  } catch (error) {
    handleErrorApi(
      dispatch,
      error,
      'Error al cargar los informes del afiliado.',
      'Ha ocurrido un error. Intente Nuevamente',
    );
  }
};

export const NuevoInformeAfiliado = (datos, turnos = false) => async (dispatch) => {
  if (datos.idAfiliado === null) {
    datos.idAfiliado = 0
  }
  if (datos.idAfiliadoExterno === null) {
    datos.idAfiliadoExterno = 0
  }
  try {
    dispatch(startSpinner());
    const response = await fetchConToken(
      `HCE/IngresoInformePaciente`,
      datos,
      'POST',
    );
    const body = await response.json();

    if (response.ok) {
      if (turnos === false) {
        dispatch(enviarPDFInforme(body[0].id));
      }
      dispatch(TraerInformesPaciente(datos.idAfiliado, datos.idAfiliadoExterno));
      dispatch(
        startAlerta(
          'Informe creado correctamente',
          'success',
          'Comando Exitoso',
        ),
      );
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      'Error al crear el informe.',
      'Ha ocurrido un error. Intente nuevamente',
    );
  }
};

export const TraerProtocolosImagenesAll = () => async (dispatch) => {
  try {
    const response = await fetchConToken(`HCE/ProtocoloImagenes`);
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.abmInformesSucces,
        payload: body,
      });
    } else {
      throw body;
    }
  } catch (error) {
    handleErrorApi(
      dispatch,
      error,
      'Error al cargar protocolos.',
      'Ha ocurrido un error. Intente Nuevamente',
    );
  }
};

export const BuscarInformes = (text) => (dispatch) => {
  dispatch({
    type: types.abmBuscarInformes,
    payload: text,
  });
};

export const BuscarInformesOftalmlogia = (text) => (dispatch) => {
  dispatch({
    type: types.abmBuscarInformesOftalmologia,
    payload: text,
  });
};

export const BuscarEstudioMedicos = (text) => (dispatch) => {
  dispatch({
    type: types.abmBuscarEstudiosMedicos,
    payload: text,
  });
};

export const TraerEfectoresMedicos = () => async (dispatch) => {
  try {
    const response = await fetchConToken(`EfectorP`);
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.ambEfectoresmedicosSucces,
        payload: body,
      });
    } else {
      throw body;
    }
  } catch (error) {
    handleErrorApi(
      dispatch,
      error,
      'Error al cargar los efectores.',
      'Ha ocurrido un error. Intente Nuevamente',
    );
  }
};

export const NuevoProtocolo = (datos) => async (dispatch) => {
  try {
    dispatch(startSpinner());

    const response = await fetchConToken(
      `HCE/ProtocoloImagenes`,
      datos,
      'POST',
    );
    const body = await response.json();

    if (response.ok) {
      dispatch(TraerProtocolosImagenesAll());
      dispatch(
        startAlerta(
          'Protocolo creado correctamente',
          'success',
          'Comando Exitoso',
        ),
      );
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      'Error al crear el protocolo.',
      'Ha ocurrido un error. Intente nuevamente',
    );
  }
};

export const ModificarProtocolo = (datos) => async (dispatch) => {
  try {
    dispatch(startSpinner());

    const response = await fetchConToken(`HCE/ProtocoloImagenes`, datos, 'PUT');
    const body = await response.json();

    if (response.ok) {
      dispatch(TraerProtocolosImagenesAll());
      dispatch(
        startAlerta(
          'Protocolo modificado correctamente',
          'success',
          'Comando Exitoso',
        ),
      );
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      'Error al modificar el protocolo.',
      'Ha ocurrido un error. Intente nuevamente',
    );
  }
};

export const enviarPDFInforme = (id) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response = await fetchConToken(`HCE/generarMail/${id}`);
      const body = await response.json();
      if (response.status === 200) {
        dispatch(
          startAlerta(
            `Mail enviado exitosamente`,
            'success',
            'Comando Exitoso',
          ),
        );
      } else {
        throw body;
      }
      dispatch(finishSpinner());
    } catch (err) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        err,
        'Ocurrio un error en el envío del PDF',
        'Ha ocurrido un error. Intente nuevamente',
      );
    }
  };
};

export const imprimirPDFInforme = (id) => {
  return async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response = await fetchConToken(`HCE/generarPDF/${id}`);
      const contentType = response.headers.get('content-type');
      if (contentType && contentType.indexOf('application/pdf') !== -1) {
        const body = await response.blob();
        if (response.ok) {
          dispatch(finishSpinner());
          window.open(URL.createObjectURL(body));

          //setRedirect && setRedirect(true);
        } else {
          throw body;
        }
      } else {
        const error = await response.json();
        dispatch(finishSpinner());
        handleErrorApi(
          dispatch,
          error,
          'Ocurrio un error en la generación del PDF',
          'Ha ocurrido un error. Intente nuevamente',
        );
      }
    } catch (err) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        err,
        'Ocurrio un error en la generación del PDF',
        'Ha ocurrido un error. Intente nuevamente',
      );
    }
  };
};

export const NuevoProblemaOdontologico = (datos) => async (dispatch) => {
  if (datos.idAfiliado === null) {
    datos.idAfiliado = 0
  }
  if (datos.idAfiliadoExterno === null) {
    datos.idAfiliadoExterno = 0
  }
  try {
    dispatch(startSpinner());

    const response = await fetchConToken(
      `HCE/IngresoProblemaOdontologico`,
      datos,
      'POST',
    );
    const body = await response.json();

    if (response.ok) {
      dispatch(fetchProblemasOdontologicosPaciente(datos.idAfiliado, datos.idAfiliadoExterno));
      dispatch(
        startAlerta(
          'Problema creado correctamente',
          'success',
          'Comando Exitoso',
        ),
      );
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      'Error al crear el problema.',
      'Ha ocurrido un error. Intente nuevamente',
    );
  }
};

export const NuevaEvolucionGeneralOdontologia = (datos) => async (dispatch) => {
  if (datos.idAfiliado === null) {
    datos.idAfiliado = 0
  }
  if (datos.idAfiliadoExterno === null) {
    datos.idAfiliadoExterno = 0
  }
  try {
    dispatch(startSpinner());

    const response = await fetchConToken(
      `HCE/IngresoEvolucionGeneralOdontologica`,
      datos,
      'POST',
    );
    const body = await response.json();

    if (response.ok) {
      dispatch(fetchEvolucionesGeneralesOdontologia(datos.idAfiliado, datos.idAfiliadoExterno));
      dispatch(
        startAlerta(
          'evolucion generada correctamente',
          'success',
          'Comando Exitoso',
        ),
      );
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      'Error al general la evolucion.',
      'Ha ocurrido un error. Intente nuevamente',
    );
  }
};

export const NuevaEvolucionOdontologia = (datos) => async (dispatch) => {
  try {
    dispatch(startSpinner());

    const response = await fetchConToken(
      `HCE/IngresoEvolucionOdontologica`,
      datos,
      'POST',
    );
    const body = await response.json();

    if (response.ok) {
      dispatch(fetchEvolucionesOdontologia(datos.idProblemaOdontologia));
      dispatch(
        startAlerta(
          'evolucion generada correctamente',
          'success',
          'Comando Exitoso',
        ),
      );
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      'Error al general la evolucion.',
      'Ha ocurrido un error. Intente nuevamente',
    );
  }
};

export const fetchEvolucionesGeneralesOdontologia =
  (idAfiliado, idAfiliadoExterno) => async (dispatch) => {
    if (idAfiliado === null) {
      idAfiliado = 0
    }
    if (idAfiliadoExterno === null) {
      idAfiliadoExterno = 0
    }
    try {
      const response = await fetchConToken(
        `HCE/TraerEvolucionesGeneralesOdontologia/${idAfiliado}/${idAfiliadoExterno}`,
      );
      const body = await response.json();

      if (response.ok) {
        dispatch({
          type: types.evolucionGeneralOdontologiaSucces,
          payload: body,
        });
      } else {
        throw body;
      }
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        'Error al cargar la informacion del afiliado.',
        'Ha ocurrido un error. Intente Nuevamente',
      );
    }
  };

export const fetchEvolucionesOdontologia =
  (idProblemaOdontologico) => async (dispatch) => {
    try {
      const response = await fetchConToken(
        `HCE/TraerEvolucionOdontologica/${idProblemaOdontologico}`,
      );
      const body = await response.json();

      if (response.ok) {
        dispatch({
          type: types.evolucionOdontologiaSucces,
          payload: body,
        });
      } else {
        throw body;
      }
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        'Error al cargar la informacion del afiliado.',
        'Ha ocurrido un error. Intente Nuevamente',
      );
    }
  };

export const fetchProblemasOdontologicosPaciente =
  (idAfiliado, idAfiliadoExterno) => async (dispatch) => {
    if (idAfiliado === null) {
      idAfiliado = 0
    }
    if (idAfiliadoExterno === null) {
      idAfiliadoExterno = 0
    }
    try {
      const response = await fetchConToken(
        `HCE/TraerProblemasOdontologicos/${idAfiliado}/${idAfiliadoExterno}`,
      );
      const body = await response.json();

      if (response.ok) {
        dispatch({
          type: types.problemasOdontologiaSucces,
          payload: body,
        });
      } else {
        throw body;
      }
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        'Error al cargar la informacion del afiliado.',
        'Ha ocurrido un error. Intente Nuevamente',
      );
    }
  };

export const pasarErrorEvolucionGeneralOdonto =
  (datos, idAfiliado, idAfiliadoExterno) => async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response = await fetchConToken(
        `HCE/PasarErrorEvolucionGeneralOdonto`,
        datos,
        'PUT',
      );
      const body = await response.json();

      if (response.ok) {
        dispatch(fetchEvolucionesGeneralesOdontologia(idAfiliado, idAfiliadoExterno));
        dispatch(
          startAlerta(
            'Evolucion eliminada correctamente',
            'success',
            'Comando Exitoso',
          ),
        );
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        'Error al eliminar la evolucion.',
        'Ha ocurrido un error. Intente nuevamente',
      );
    }
  };

export const pasarErrorEvolucionOdonto =
  (datos, idProblema) => async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response = await fetchConToken(
        `HCE/PasarErrorEvolucionOdontologica`,
        datos,
        'PUT',
      );
      const body = await response.json();

      if (response.ok) {
        dispatch(fetchEvolucionesOdontologia(idProblema));
        dispatch(
          startAlerta(
            'Evolucion eliminada correctamente',
            'success',
            'Comando Exitoso',
          ),
        );
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        'Error al eliminar la evolucion.',
        'Ha ocurrido un error. Intente nuevamente',
      );
    }
  };

export const pasarErrorProblemaOdonto =
  (datos, idAfiliado, idAfiliadoExterno) => async (dispatch) => {
    try {
      dispatch(startSpinner());
      const response = await fetchConToken(
        `HCE/PasarErrorProblemaOdontologico`,
        datos,
        'PUT',
      );
      const body = await response.json();

      if (response.ok) {
        dispatch(fetchProblemasOdontologicosPaciente(idAfiliado, idAfiliadoExterno));
        dispatch(
          startAlerta(
            'Problema eliminado correctamente',
            'success',
            'Comando Exitoso',
          ),
        );
        dispatch(finishSpinner());
      } else {
        throw body;
      }
    } catch (error) {
      dispatch(finishSpinner());
      handleErrorApi(
        dispatch,
        error,
        'Error al eliminar el problema.',
        'Ha ocurrido un error. Intente nuevamente',
      );
    }
  };

export const traerSignosVitales = (idAfiliado, idAfiliadoExterno) => async (dispatch) => {
  if (idAfiliado === null) {
    idAfiliado = 0
  }
  if (idAfiliadoExterno === null) {
    idAfiliadoExterno = 0
  }
  try {
    const response = await fetchConToken(
      `HCE/TraerSignosVitales/${idAfiliado}/${idAfiliadoExterno}`,
    );
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.signosVitalesSuccess,
        payload: body,
      });
    } else {
      throw body;
    }
  } catch (error) {
    handleErrorApi(
      dispatch,
      error,
      'Error al cargar signos vitales.',
      'Ha ocurrido un error. Intente Nuevamente',
    );
  }
};

export const postSignosVitales = (datos, setModal) => async (dispatch) => {
  try {
    dispatch(startSpinner());

    const response = await fetchConToken(`HCE/SignosVitales`, datos, 'POST');
    const body = await response.json();

    if (response.ok) {
      dispatch(traerSignosVitales(datos?.idAfiliado, datos?.idAfiliadoExterno));
      dispatch(
        startAlerta(
          'Signos Vitales registrados correctamente',
          'success',
          'Comando Exitoso',
        ),
      );
      dispatch(finishSpinner());
      setModal(false);
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      'Error al crear el problema.',
      'Ha ocurrido un error. Intente nuevamente',
    );
  }
};

export const traerEfectorMedicoPorDni =
  (dniProfesional) => async (dispatch) => {
    try {
      const response = await fetchConToken(
        `HCE/TraerEfectorMedicoPorDNI/${dniProfesional}`,
      );
      const body = await response.json();

      if (response.ok) {
        dispatch({
          type: types.listaEfectorMedicoSucess,
          payload: body,
        });
      } else {
        throw body;
      }
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        'Error al cargar la informacion del efector médico.',
        'Ha ocurrido un error. Intente Nuevamente',
      );
    }
  };

export const traerRelacionEfectorCMEspecialidad =
  (idEfectorRed) => async (dispatch) => {
    try {
      const response = await fetchConToken(
        `HCE/TraerRelacionEfectorCMEspecialidad/${idEfectorRed}`,
      );
      const body = await response.json();

      if (response.ok) {
        dispatch({
          type: types.relacionEfectorCMEspeSucess,
          payload: body,
        });
      } else {
        throw body;
      }
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        'Error al cargar la informacion.',
        'Ha ocurrido un error. Intente Nuevamente',
      );
    }
  };

export const traerPisoConsultorio =
  (idEfector, idCentroMedico, fecha) => async (dispatch) => {
    try {
      let fechaModif = fecha instanceof Date ? moment(fecha).format() : '';
      const response = await fetchConToken(
        `HCE/TraerPIsoConsultorio/${idEfector},${idCentroMedico},${fechaModif}`,
      );
      const body = await response.json();

      if (response.ok) {
        dispatch({
          type: types.pisoConsultorioEfectorSucess,
          payload: body,
        });
      } else {
        throw body;
      }
    } catch (error) {
      handleErrorApi(
        dispatch,
        error,
        'Error al cargar la informacion.',
        'Ha ocurrido un error. Intente Nuevamente',
      );
    }
  };


export const marcarTurnoAtendido = (datos) => async (dispatch) => {
  try {
    dispatch(startSpinner());

    const response = await fetchConToken(`Agenda/marcarTurnoAtendido`, datos, 'PUT');
    const body = await response.json();

    if (response.ok) {
      dispatch(
        startAlerta(
          'llamado correctamente',
          'success',
          'Comando Exitoso',
        ),
      );
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      'Error al llamar.',
      'Ha ocurrido un error. Intente nuevamente',
    );
  }
};

export const generatePDFHceAfiliado = (idAfiliado, idAfiliadoExterno, historiaClinica, historiaClinicaOdontologica) => async (dispatch, getState) => {
  if (idAfiliado === null) {
    idAfiliado = 0
  }
  if (idAfiliadoExterno === null) {
    idAfiliadoExterno = 0
  }
  dispatch(startSpinner());
  try {
    const response = await fetchConToken(
      `HCE/GenerarPDFHCEAfiliado/${idAfiliado}/${idAfiliadoExterno}/${historiaClinica}/${historiaClinicaOdontologica}`,
    );
    const body = await response.blob();
    if (response.ok) {
      dispatch(finishSpinner());
      window.open(URL.createObjectURL(body));
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      "Error al traer el pdf",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
}


export const DescargarPlantillaEmpadronamientoHCE = (tipoArchivo) => async (dispatch, getState) => {
  let file;
  if (tipoArchivo === TIPOS_ARCHIVOS_EMPADRONAMIENTO_HCE.CRONICOS) {
    file = "EMPADRONAMIENTOCRONICOS.docx";
  } else if (tipoArchivo === TIPOS_ARCHIVOS_EMPADRONAMIENTO_HCE.DIABETES) {
    file = "EMPADRONAMIENTODIABETES.docx";
  } else if (tipoArchivo === TIPOS_ARCHIVOS_EMPADRONAMIENTO_HCE.ONCOLOGIA) {
    file = "PATOLOGIASONCOLOGICAS.docx";
  }
  const url = `${process.env.REACT_APP_URL}/public-templates/${file}`;

  const token =
    localStorage.getItem("token") || sessionStorage.getItem("token") || "";
  let httpHeaders;
  if (token) {
    httpHeaders = {
      Authorization: `Bearer ${token}`,
    };
  }
  try {
    Axios({
      url: url,
      method: "GET",
      responseType: "blob",
      headers: httpHeaders,
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", file);
      document.body.appendChild(link);
      link.click();
    });
  } catch (error) {
    handleErrorApi(
      dispatch,
      error,
      "Error al subir el archivo",
      "Ha ocurrido un error. Intente nuevamente"
    );
  }
};

export const getAutopercepcionPorAfiliadoHCE = (idAfiliado) => {
  return async (dispatch) => {
    dispatch(startSpinner());
    try {
      const response = await fetchConToken(
        `AutopercepcionAfiliado/${idAfiliado}`
      );
      if (response.ok && response.status === 204) {     // No-Content
        dispatch({ type: types.hceAutopercepcionAfiliadoGetSuccess, payload: null });
      } else {
        const body = await response.json();
        if (!response.ok) {
          throw body;
        }
        dispatch({ type: types.hceAutopercepcionAfiliadoGetSuccess, payload: body });
      }
    } catch (error) {
      dispatch({ type: types.hceAutopercepcionAfiliadoGetError });
      handleErrorApi(
        dispatch,
        error,
        "Error al traer autopercepción.",
        "Ha ocurrido un error. Intente nuevamente"
      );
    }
    dispatch(finishSpinner());
  };
};

export const ingresarCelularContacto = (datos) => async (dispatch) => {
  try {
    dispatch(startSpinner());

    const response = await fetchConToken(`HCE/IngresoCelularContacto`, datos, 'PUT');
    const body = await response.json();

    if (response.ok) {
      dispatch(
        startAlerta(
          'Celular ingresado/modificado correctamente',
          'success',
          'Comando Exitoso',
        ),
      );
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      'Error al ingresar/modificar el celular de contacto.',
      'Ha ocurrido un error. Intente nuevamente',
    );
  }
};

export const traerVacunas = (idAfiliado, idAfiliadoExterno) => async (dispatch) => {
  if (idAfiliado === null) {
    idAfiliado = 0
  }
  if (idAfiliadoExterno === null) {
    idAfiliadoExterno = 0
  }
  try {
    const response = await fetchConToken(
      `HCE/Vacunas/${idAfiliado}/${idAfiliadoExterno}`,
    );
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.vacunasSuccess,
        payload: body,
      });
    } else {
      throw body;
    }
  } catch (error) {
    handleErrorApi(
      dispatch,
      error,
      'Error al cargar las vacunas.',
      'Ha ocurrido un error. Intente Nuevamente',
    );
  }
};

export const postVacunas = (datos, setModal) => async (dispatch) => {
  try {
    dispatch(startSpinner());

    const response = await fetchConToken(`HCE/Vacunas`, datos, 'POST');
    const body = await response.json();

    if (response.ok) {
      dispatch(traerVacunas(datos?.idAfiliado, datos?.idAfiliadoExterno));
      dispatch(
        startAlerta(
          'Vacuna registrada correctamente',
          'success',
          'Comando Exitoso',
        ),
      );
      dispatch(finishSpinner());
      setModal(false);
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      'Error al ingresar la vacuna.',
      'Ha ocurrido un error. Intente nuevamente',
    );
  }
};

export const traerMedicacionActiva = (idAfiliado, idAfiliadoExterno) => async (dispatch) => {
  if (idAfiliado === null) {
    idAfiliado = 0
  }
  if (idAfiliadoExterno === null) {
    idAfiliadoExterno = 0
  }
  try {
    const response = await fetchConToken(
      `HCE/MedicacionActiva/${idAfiliado}/${idAfiliadoExterno}`,
    );
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.medicacionActivaSuccess,
        payload: body,
      });
    } else {
      throw body;
    }
  } catch (error) {
    handleErrorApi(
      dispatch,
      error,
      'Error al traer la medicaciòn activa.',
      'Ha ocurrido un error. Intente Nuevamente',
    );
  }
};


export const postMedicacionActiva = (datos, setModal) => async (dispatch) => {
  try {
    dispatch(startSpinner());

    const response = await fetchConToken(`HCE/MedicacionActiva`, datos, 'POST');
    const body = await response.json();

    if (response.ok) {
      dispatch(traerMedicacionActiva(datos?.idAfiliado, datos?.idAfiliadoExterno));
      dispatch(
        startAlerta(
          'medicación activa registrada correctamente',
          'success',
          'Comando Exitoso',
        ),
      );
      dispatch(finishSpinner());
      setModal(false);
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      'Error al ingresar la medicación activa.',
      'Ha ocurrido un error. Intente nuevamente',
    );
  }
};

export const putMedicacionActiva = (datos, setModal) => async (dispatch) => {
  try {
    dispatch(startSpinner());

    const response = await fetchConToken(`HCE/MedicacionActiva`, datos, 'PUT');
    const body = await response.json();

    if (response.ok) {
      dispatch(traerMedicacionActiva(datos?.idAfiliado, datos?.idAfiliadoExterno));
      dispatch(
        startAlerta(
          'medicación activa finalizada correctamente',
          'success',
          'Comando Exitoso',
        ),
      );
      dispatch(finishSpinner());
      setModal(false);
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      'Error al finalizar la medicación activa.',
      'Ha ocurrido un error. Intente nuevamente',
    );
  }
};

export const traerProtocolosOftalmologia = () => async (dispatch) => {
  try {
    const response = await fetchConToken(
      `HCE/ProtocoloOftalmologia/`,
    );
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.protocolosOftalmologiaActivaSuccess,
        payload: body,
      });
    } else {
      throw body;
    }
  } catch (error) {
    handleErrorApi(
      dispatch,
      error,
      'Error al traer los protocolos.',
      'Ha ocurrido un error. Intente Nuevamente',
    );
  }
};

export const putProtocolosOftalmologia = (datos) => async (dispatch) => {
  try {
    dispatch(startSpinner());

    const response = await fetchConToken(`HCE/ProtocoloOftalmologia`, datos, 'PUT');
    const body = await response.json();

    if (response.ok) {
      dispatch(
        startAlerta(
          'Protocolo modificado correctamente',
          'success',
          'Comando Exitoso',
        ),
      );
      dispatch(traerProtocolosOftalmologia());
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      'Error al modificar el protocolo.',
      'Ha ocurrido un error. Intente nuevamente',
    );
  }
};



export const postProtocolosOftalmologia = (datos) => async (dispatch) => {
  try {
    dispatch(startSpinner());

    const response = await fetchConToken(`HCE/ProtocoloOftalmologia`, datos, 'POST');
    const body = await response.json();

    if (response.ok) {
      dispatch(
        startAlerta(
          'Protocolo ingresado correctamente',
          'success',
          'Comando Exitoso',
        ),
      );
      dispatch(traerProtocolosOftalmologia());
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      'Error al ingresar el protocolo.',
      'Ha ocurrido un error. Intente nuevamente',
    );
  }
};

export const traerInformesOftalmologia = (idAfiliado, idAfiliadoExterno) => async (dispatch) => {
  if (idAfiliado === null) {
    idAfiliado = 0
  }
  if (idAfiliadoExterno === null) {
    idAfiliadoExterno = 0
  }
  try {
    const response = await fetchConToken(
      `HCE/Oftalmologia/${idAfiliado}/${idAfiliadoExterno}`,
    );
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.informesOftalmologiaActivaSuccess,
        payload: body,
      });
    } else {
      throw body;
    }
  } catch (error) {
    handleErrorApi(
      dispatch,
      error,
      'Error al traer la medicaciòn activa.',
      'Ha ocurrido un error. Intente Nuevamente',
    );
  }
};

export const postInformeOftalmologia = (datos) => async (dispatch) => {
  try {
    dispatch(startSpinner());

    const response = await fetchConToken(`HCE/Oftalmologia`, datos, 'POST');
    const body = await response.json();

    if (response.ok) {
      dispatch(
        startAlerta(
          'Informe ingresado correctamente',
          'success',
          'Comando Exitoso',
        ),
      );
      dispatch(traerInformesOftalmologia(datos?.idAfiliado, datos?.idAfiliadoExterno));
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      'Error al ingresar el informe.',
      'Ha ocurrido un error. Intente nuevamente',
    );
  }
};

export const traerEstudiosSolicitados = (idAfiliado, idAfiliadoExterno) => async (dispatch) => {
  if (idAfiliado === null) {
    idAfiliado = 0
  }
  if (idAfiliadoExterno === null) {
    idAfiliadoExterno = 0
  }
  try {
    const response = await fetchConToken(
      `HCE/EstudiosSolicitados/${idAfiliado}/${idAfiliadoExterno}`,
    );
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.estudiosSolicitadosSucess,
        payload: body,
      });
    } else {
      throw body;
    }
  } catch (error) {
    handleErrorApi(
      dispatch,
      error,
      'Error al traer los estudios solicitados.',
      'Ha ocurrido un error. Intente Nuevamente',
    );
  }
};


export const traerEstudiosMedicos = () => async (dispatch) => {
  try {
    const response = await fetchConToken(
      `HCE/EstudiosMedicos/`,
    );
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.estudiosMedicosSucess,
        payload: body,
      });
    } else {
      throw body;
    }
  } catch (error) {
    handleErrorApi(
      dispatch,
      error,
      'Error al traer los estudios medicos.',
      'Ha ocurrido un error. Intente Nuevamente',
    );
  }
};


export const postEstudiosSolicitados = (datos) => async (dispatch) => {
  try {
    dispatch(startSpinner());

    const response = await fetchConToken(`HCE/EstudiosSolicitados`, datos, 'POST');
    const body = await response.json();

    if (response.ok) {
      dispatch(
        startAlerta(
          'Estudio ingresado correctamente',
          'success',
          'Comando Exitoso',
        ),
      );
      dispatch(traerEstudiosSolicitados(datos?.idAfiliado, datos?.idAfiliadoExterno));
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      'Error al ingresar el Estudio.',
      'Ha ocurrido un error. Intente nuevamente',
    );
  }
};

export const postEstudiosMedicos = (datos) => async (dispatch) => {
  try {
    dispatch(startSpinner());

    const response = await fetchConToken(`HCE/EstudiosMedicos`, datos, 'POST');
    const body = await response.json();

    if (response.ok) {
      dispatch(
        startAlerta(
          'Estudio ingresado correctamente',
          'success',
          'Comando Exitoso',
        ),
      );
      dispatch(traerEstudiosMedicos());
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      'Error al ingresar el Estudio.',
      'Ha ocurrido un error. Intente nuevamente',
    );
  }
};

export const putEstudiosMedicos = (datos) => async (dispatch) => {
  try {
    dispatch(startSpinner());

    const response = await fetchConToken(`HCE/EstudiosMedicos`, datos, 'PUT');
    const body = await response.json();

    if (response.ok) {
      dispatch(
        startAlerta(
          'Estudio modificar correctamente',
          'success',
          'Comando Exitoso',
        ),
      );
      dispatch(traerEstudiosMedicos());
      dispatch(finishSpinner());
    } else {
      throw body;
    }
  } catch (error) {
    dispatch(finishSpinner());
    handleErrorApi(
      dispatch,
      error,
      'Error al modificar el Estudio.',
      'Ha ocurrido un error. Intente nuevamente',
    );
  }
};

export const traerTurnosAfiliadoHCE = (idAfiliado, idAfiliadoExterno) => async (dispatch) => {
  if (idAfiliado === null) {
    idAfiliado = 0
  }
  if (idAfiliadoExterno === null) {
    idAfiliadoExterno = 0
  }
  try {
    const response = await fetchConToken(
      `HCE/TraerTurnosAfiliado/${idAfiliado}/${idAfiliadoExterno}`,
    );
    const body = await response.json();
    if (response.ok) {
      dispatch({
        type: types.turnosAfiliadosSucess,
        payload: body,
      });
    } else {
      throw body;
    }
  } catch (error) {
    handleErrorApi(
      dispatch,
      error,
      'Error al traer los turnos.',
      'Ha ocurrido un error. Intente Nuevamente',
    );
  }
};